import type { Page } from '../../types';

const criminalProsecutionsBribery: Page[] = [
  {
    pageType: 'question',
    title: 'Criminal prosecutions for bribery',
    name: 'criminal-prosecutions-bribery-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any criminal prosecutions for bribery to declare?',
        name: 'prosecutions_criminal_bribery_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Criminal prosecutions for bribery',
    name: 'criminal-prosecutions-bribery',
    type: 'nilreturn',
    fastToggle: true,
    disabled: [
      {
        field: 'prosecutions_criminal_bribery_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'instanceInput',
        title: 'How many prosecutions were referred?',
        name: 'prosecutions_criminal_bribery_referral',
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'instanceInput',
        title: 'How many prosecutions proceeded to charge?',
        name: 'prosecutions_criminal_bribery_proceed_charged',
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'instanceInput',
        title: 'How many prosecutions were successful?',
        name: 'prosecutions_criminal_bribery_successful',
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'prosecutions_criminal_bribery_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default criminalProsecutionsBribery;




